import { render } from "./AvatarComponent.vue?vue&type=template&id=04b6d4c1&scoped=true"
import script from "./AvatarComponent.vue?vue&type=script&lang=js"
export * from "./AvatarComponent.vue?vue&type=script&lang=js"

import "./AvatarComponent.vue?vue&type=style&index=0&id=04b6d4c1&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04b6d4c1"]])

export default __exports__